import { render, staticRenderFns } from "./Scaner.vue?vue&type=template&id=28a5ff0a&scoped=true&"
import script from "./Scaner.vue?vue&type=script&lang=js&"
export * from "./Scaner.vue?vue&type=script&lang=js&"
import style0 from "./Scaner.vue?vue&type=style&index=0&id=28a5ff0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a5ff0a",
  null
  
)

export default component.exports